import { NewsDto } from './news.dto';

export class News {
    id: string;
    title: string;
    description: string;
    date: Date;

    constructor(data: NewsDto) {
        this.id = data.id;
        this.title = data.title;
        this.description = data.description;
        this.date = new Date(data.date);
    }
}
